import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export var TICKETS_ENABLED = false;

export function useTicketsRedirect(): boolean {
    var history = useHistory();

    useEffect(function () {
        if (!TICKETS_ENABLED) {
            history.replace("/profile");
        }
    }, []);

    return TICKETS_ENABLED;
}
